import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden mt-20">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/32939a82f0d0c482147240e4428c10c7.jpg"
            alt="خدماتنا"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-primary/75"></div>
        </div>

        <div className="relative z-10 container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-6xl md:text-7xl font-black text-white mb-6">خدماتنا</h1>
            <p className="text-2xl text-accent font-bold">حلول شاملة لجميع احتياجاتك</p>
          </motion.div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-black text-primary mb-4">ماذا نقدم؟</h2>
            <div className="w-20 h-1 bg-accent mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              نوفر مجموعة شاملة من الخدمات المتخصصة في تأجير الرافعات والمعدات الثقيلة
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-truck-fill',
                title: 'تأجير الرافعات الهيدروليكية',
                description: 'أسطول ضخم من الرافعات بقدرات من 7 إلى 300 طن',
              },
              {
                icon: 'ri-tools-fill',
                title: 'تأجير المعدات الإنشائية',
                description: 'معدات متنوعة لجميع أنواع المشاريع الإنشائية',
              },
              {
                icon: 'ri-settings-3-fill',
                title: 'الصيانة والإصلاح',
                description: 'خدمات صيانة دورية وإصلاح فوري للمعدات',
              },
              {
                icon: 'ri-roadster-fill',
                title: 'النقل والتوصيل',
                description: 'نقل المعدات إلى موقع مشروعك بأمان وسرعة',
              },
              {
                icon: 'ri-user-star-fill',
                title: 'توفير مشغلين محترفين',
                description: 'مشغلون مدربون ومعتمدون لتشغيل المعدات',
              },
              {
                icon: 'ri-customer-service-2-fill',
                title: 'الدعم الفني 24/7',
                description: 'فريق دعم فني متاح على مدار الساعة',
              },
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all group cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-accent/10 group-hover:bg-accent rounded-xl mb-6 transition-all">
                  <i className={`${service.icon} text-4xl text-accent group-hover:text-primary transition-all`}></i>
                </div>
                <h3 className="text-xl font-bold text-primary mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Safety Section */}
      <section className="py-24 bg-primary">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="w-24 h-24 flex items-center justify-center bg-accent rounded-full mx-auto mb-8">
                <i className="ri-shield-star-fill text-6xl text-primary"></i>
              </div>
              <h2 className="text-5xl md:text-6xl font-black text-white mb-6">السلامة والجودة</h2>
              <p className="text-2xl text-gray-300 mb-12 leading-relaxed">
                نلتزم بأعلى معايير السلامة والجودة في جميع خدماتنا
              </p>

              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                {[
                  { icon: 'ri-award-fill', title: 'شهادة TÜV', desc: 'معتمدون دولياً' },
                  { icon: 'ri-tools-fill', title: 'صيانة دورية', desc: 'فحص شامل منتظم' },
                  { icon: 'ri-user-star-fill', title: 'مشغلون محترفون', desc: 'مدربون ومعتمدون' },
                  { icon: 'ri-shield-check-fill', title: 'معايير السلامة', desc: 'التزام كامل' },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all"
                  >
                    <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                      <i className={`${item.icon} text-5xl text-accent`}></i>
                    </div>
                    <h4 className="text-white font-bold text-lg mb-2">{item.title}</h4>
                    <p className="text-gray-400 text-sm">{item.desc}</p>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl md:text-6xl font-black text-primary mb-6">
              احصل على عرض سعر مخصص
            </h2>
            <p className="text-2xl text-gray-600 mb-12 max-w-3xl mx-auto">
              تواصل معنا الآن واحصل على استشارة مجانية وعرض سعر يناسب احتياجات مشروعك
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              <a
                href="tel:920000000"
                className="bg-accent hover:bg-accent-dark text-primary px-12 py-5 rounded-xl font-black text-xl transition-all shadow-2xl hover:shadow-accent/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
              >
                <i className="ri-phone-fill text-2xl"></i>
                <span>اتصل بنا: 920000000</span>
              </a>
              <a
                href="https://wa.me/966500000000"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary hover:bg-primary-dark text-white px-12 py-5 rounded-xl font-bold text-xl transition-all shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
              >
                <i className="ri-whatsapp-fill text-2xl"></i>
                <span>واتساب</span>
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;